import { gql } from "@apollo/client";

export const GET_ADDON_RATE_CARDS = gql`
  query addonRateCards {
    addonRateCards {
      id
      name
      isActive
      isDefault
      displayName
      dateUpdated
      lastUpdatedBy {
        firstName
        lastName
      }
      businessCustomers {
        businessName
        id
      }
      addons {
        name
        pricing {
          rangeStart
          rangeEnd
          unitPrice
        }
        addon {
          id
          name
        }
      }
    }
  }
`;
